/**
 * "Tue, 27 Oct, 09:00" - a CIVIL DATE and a wall-clock time, for the account
 * bookings pane (T1746 M4, ux review WARN 1).
 *
 * ⭐ Board 2812 M1 - MOVED HERE FROM `client/lib/format.ts`, body unchanged, so
 * the server can word `needsHelenNow`'s DD-17 mismatch line through the same
 * function (`shared/needs-helen-now.ts`). `format.ts` re-exports it, so every
 * client import is untouched. ⛔ It lives in its own file because `format.ts`
 * imports `@ecmb/ui`, which must never reach `src/shared`.
 *
 * ⛔ NOT `shortDateTime`, AND THE DIFFERENCE IS THE BUG THIS FIXES. The
 * helpers beside it take an INSTANT and format it in Dublin. This takes a civil
 * date (`YYYY-MM-DD`, no zone, as `bookings.journey_date` stores it) and a separate
 * `HH:MM` string. `new Date('2026-10-27')` is parsed as UTC MIDNIGHT, so
 * formatting it in any zone west of Greenwich renders the 26th: the journey
 * would silently move a day. Building the components into `new Date(y, m - 1,
 * d)` makes a LOCAL midnight, which is the same calendar day in every zone.
 *
 * ⛔ AND THE COMPONENTS ARE RANGE-CHECKED BY ROUND TRIP, because the
 * constructor ROLLS OVER rather than refusing: `new Date(2026, 12, 45)` is a
 * real date in February 2027, so a `2026-13-45` that satisfied the regex would
 * render a confident wrong day. Reading the month and date back is what turns
 * that into the '' every helper beside this one answers on junk.
 *
 * ⚠️ The shape matches the Requests table one tab away
 * (`PortalRequests.tsx`, `weekday/day/month` + the time), which is the finding:
 * two nursing-home screens were rendering the same fact two ways, and the raw
 * ISO form wrapped mid-token at 1024 wide.
 */
export function civilDateLabel(civil: string, time: string | null): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(civil);
  if (m == null) return '';
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(y, mo - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return '';
  const label = date.toLocaleDateString('en-IE', { weekday: 'short', day: 'numeric', month: 'short' });
  return time != null && time !== '' ? `${label}, ${time}` : label;
}
